import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSearchParams } from "react-router-dom";
import Wallet from "../wallet";
import { useState } from "react";
import { saveData, type WalletDetails } from "@/shared";

const CreateWallet = () => {
	const [searchParams] = useSearchParams();
	const chainParam = searchParams.get("chain") || "solana";
	const chain = chainParam === "ethereum" ? "ethereum" : "solana";
	const [name, setName] = useState("");
	const [mnemonic, setMnemonic] = useState<string>("");
	const [walletDetails, setWalletDetails] = useState<WalletDetails[]>([]);

	const handleCreateWallet = () => {
		if (!chain) return;

		let currentMnemonic = mnemonic;
		if (!currentMnemonic) {
			currentMnemonic = Wallet.generateRandom();
			setMnemonic(currentMnemonic);
		}

		const walletName =
			name.trim() ||
			`${chain.charAt(0).toUpperCase() + chain.slice(1)} Wallet ${walletDetails.length + 1}`;
		const wallet = new Wallet(chain, walletDetails.length);
		const { publicKey, privateKey } = wallet.importWallet(currentMnemonic);

		const newWallet: WalletDetails = {
			type: chain,
			name: walletName,
			publicKey,
			privateKey,
		};

		const updatedWallets = [...walletDetails, newWallet];
		setWalletDetails(updatedWallets);
		saveData(currentMnemonic, updatedWallets);
		setName("");
		window.location.href = "/dashboard";
	};

	return (
		<section className="flex-1 flex items-center justify-center px-6">
			<Card className="w-full max-w-lg bg-neutral-950 border-neutral-800">
				<CardHeader>
					<CardTitle className="text-2xl text-white">Create New Wallet</CardTitle>
					<CardDescription className="text-neutral-500">
						A new {chain} wallet will be created with a 12-word recovery phrase. Make sure to save
						it securely!
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-4">
					<div>
						<Input
							placeholder="Enter a name for your wallet (optional)"
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							className="h-12 bg-neutral-900 border-neutral-800 text-white placeholder:text-neutral-600 focus-visible:ring-white/20 rounded-xl"
						/>
					</div>
					<Button
						onClick={handleCreateWallet}
						className="w-full h-12 bg-white hover:bg-neutral-200 text-black font-semibold rounded-xl"
					>
						Create Wallet
					</Button>
				</CardContent>
			</Card>
		</section>
	);
};

export default CreateWallet;
